/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

import ListManagementMerchant from '../views/user-management-merchant/ListUserMerchant.vue';
import DetailManagementMerchant from '../views/user-management-merchant/DetailUserMerchant.vue';

import { setBreadcrumb } from './index';

const userMerchantManagementRoute = {
  path: '/merchant-management',
  name: 'ManagementMerchant',
  meta: {
    title: 'BNI QRIS - User Merchant Management',
    appBarTitle: 'User Merchant Management',
  },
  component: Parent,
  children: [
    {
      path: '/user-management-merchant/:type',
      meta: {
        title: `BNI QRIS - User Merchant Management `,
        appBarTitle: `User Merchant Management`,
        breadcrumbs: (params) => [
          setBreadcrumb(
            `user merchant management - ${params.type} merchant`,
            `/user-management-merchant/${params.type}`,
            true
          ),
          setBreadcrumb(
            'list merchant',
            `/user-management-merchant/${params.type}`
          ),
        ],
      },
      component: ListManagementMerchant,
      name: 'ListManagementMerchant',
    },
    {
      path: '/user-management-merchant/:type/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - User Merchant Management Detail',
        appBarTitle: 'Merchant Detail',
        breadcrumbs: (params) => {
          const { id } = params;
          const urlType =
            params.type == 'portal'
              ? '/user-management-merchant/portal'
              : '/user-management-merchant/mobile';

          return [
            setBreadcrumb(
              'user merchant management',
              '/user-management-merchant',
              true
            ),
            setBreadcrumb('list merchant', urlType),
            setBreadcrumb(
              `detail merchant ${id}`,
              `/user-management-merchant/${id}`,
              true
            ),
          ];
        },
      },
      component: DetailManagementMerchant,
      name: 'DetailManagementMerchant',
    },
  ],
};

export default userMerchantManagementRoute;
